export { isNewsUnread } from './is-news-unread';
export { NEWS_READ_IDS_KEY, addNewsReadId, getNewsReadIds, useGuestNewsReadIds } from './news-read-storage';
export {
    mapCustomerNotificationToNewsModalProps,
    type NewsModalContentProps,
} from '@/entities/customer-notification/lib/map-notification';
export { markNewsRead } from './mark-news-read';
export {
    openCustomerNotification,
    openCustomerNotificationToast,
    openNewsDetailFromToast,
    type NewsReadPolicy,
} from './open-customer-notification';
export { useNewsUnread } from './useNewsUnread';
export {
    CustomerNotificationItemContext,
    CustomerNotificationItemProvider,
    useCustomerNotificationItem,
} from './customer-notification-item-context';
export { useCustomerNotificationsList } from './useCustomerNotificationsList';
export { useNewsAutoShow } from './useNewsAutoShow';
